import { TaxonomyListPage } from '../taxonomy/TaxonomyListPage.js';

export function CarBrandListPage() {
  return (
    <TaxonomyListPage
      config={{
        title: 'Car Brands',
        description: 'Global vehicle brand catalog (Toyota, Honda…).',
        apiPath: '/car-brands',
        basePath: '/car-brands',
        resource: 'carBrand',
        subject: 'CarBrand',
        entityLabel: 'brand',
      }}
    />
  );
}
